export default __webpack_public_path__ + "68ca2c7a97e6dbf6ff0b8bb88485c63c.png";